import { ISliderBlockTypeOneSlideModel } from '../ISliderBlockTypeOneSlideModel';

/**
 * @description Модель слайда слайдера типа один. Слайдер представляет собой виджет, который содержит в себе список слайдов и чипы для выбора набора слайдов.
 * Сам слайд содержит в себе изображение снизу, заголовок и описание сверху.
 * @param title - Заголовок слайда.
 * @param description - Описание слайда.
 * @param imageUrl - URL изображения.
 * @example
 * const sliderBlockTypeOneSlideModel = new SliderBlockTypeOneSlideModel('Первый заголовок у первого набора слайдов', 'Первое описание у первого набора слайдов', 'imageUrlOne');
 * const title = sliderBlockTypeOneSlideModel.title;
 * const description = sliderBlockTypeOneSlideModel.description;
 * const imageUrl = sliderBlockTypeOneSlideModel.imageUrl;
 */
export class SliderBlockTypeOneSlideModel implements ISliderBlockTypeOneSlideModel {
  public readonly title: ISliderBlockTypeOneSlideModel['title'];
  public readonly description: ISliderBlockTypeOneSlideModel['description'];
  public readonly imageUrl: ISliderBlockTypeOneSlideModel['imageUrl'];

  public constructor(
    title: ISliderBlockTypeOneSlideModel['title'],
    description: ISliderBlockTypeOneSlideModel['description'],
    imageUrl: ISliderBlockTypeOneSlideModel['imageUrl'],
  ) {
    this.title = title;
    this.description = description;
    this.imageUrl = imageUrl;
  }
}
